import styled from "styled-components";

export const UsersOverAllWrapper = styled.div``;

export const UsersWrapper = styled.div`
.temporary-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  @media (max-width: 546px) {
    flex-wrap: wrap;
    justify-content: start;
  }
}
`;
export const AddUsersWrapper = styled.div`
  .tabs-header-wrapper {
    margin: 12px 12px 0 12px;
    border-radius: 12px 12px 0 0;
    background-color: var(--white);

  }
  .addAnotherUserBtn {
    margin-left: auto;
    margin-right: 13px;
  }
  .user-personal-info .info-item {
    /* border-bottom: 2px solid var(--borderLight); */

    label {
      min-width: 160px;
    }
  }
  .location-map-cont .location-map {
    width: 100%;
    height: 230px;
    border-radius: 10px;
  }
`;
export const UserDetailsWrapper = styled.div`
  .user-info-box {
    /* border-right: 1px solid var(--borderLight); */
    & > div {
      padding: 1rem;
      /* border-bottom: 1px solid var(--borderLight); */
    }
    body.rtl & {
      border-right: 0;
      /* border-left: 1px solid var(--borderLight); */
    }
  }
`
export const SelectedItemWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  padding: 8px 16px;
  background-color: var(--bgSecondary);
  border-radius: 10px;
  .userPlaceholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    max-width: 30px;
    height: 30px;
    background-color: var(--greyBg);
    border-radius: 50%;
    // border: 1px dashed var(--greyText);
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  svg.removeTaskTrigger {
    width: 12px;
    height: 12px;
    margin-left: 7px;
    &:hover {
      stroke: var(--redColor);
      fill: var(--redColor);
      path {
        stroke: var(--redColor);
        fill: var(--redColor);
      }
    }
  }
  input[type="file"] {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .abtUser {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    span {
      // width: 100%;
    }
  }
`;

export const ImportUserHyperLink = styled.a`
color: var(--themeColor);
font-size: 12px;
`